//DEFAULTS
import "imports/core-js/stable";
import "imports/regenerator-runtime/runtime";

//import overlay from 'site/overlay'
import site from 'site/site'
import siteHeader from 'site/siteHeader'
import home from 'site/home'
import homeHero from 'site/homeHero'
import homeMoments from 'site/homeMoments'
import homeAlumni from 'site/homeAlumni'
import wnYearSubnav from 'site/wnYearSubnav'
import videosYearPicker from 'site/videosYearPicker'
import videosBgScene from 'site/videosBgScene'
import theJimmyBgScene from 'site/theJimmyBgScene'
import wnEnsembleBgScene from 'site/wnEnsembleBgScene'
import homeSmugmugBgScene from 'site/homeSmugmugBgScene'
import wnJnotePosition from 'site/wnJnotePosition'
import lenisSmooth from 'site/lenisSmooth'
import autoHeadingIds from 'site/autoHeadingIds'
import faq from 'site/faq'
import imageCarousel from 'site/imageCarousel'
import imageModal from 'site/imageModal'
import broadwayShows from 'site/broadwayShows'
import lottieRollover from 'site/lottieRollover'
import scrollCue from 'site/scrollCue'
import star from 'site/star'
import global from 'site/global'
import siteScroll from 'site/scroll'
import mobileNav from 'site/mobileNav'
import mobileSubNav from 'site/mobileSubNav'
import singleVideo from 'site/singleVideo'
import siteAOS from 'site/site.aos'
$(document).ready(function() {
    // Lenis first so other modules' scroll listeners see smoothed values.
    lenisSmooth.init()
    // Heading IDs need to be assigned before any anchor click is possible.
    autoHeadingIds.init()
    mobileNav.init()
    mobileSubNav.init()
    site.init()
    siteHeader.init()
    global.init()
    siteScroll.init()
    home.init()
    homeHero.init()
    homeMoments.init()
    homeAlumni.init()
    wnYearSubnav.init()
    videosYearPicker.init()
    videosBgScene.init()
    theJimmyBgScene.init()
    wnEnsembleBgScene.init()
    homeSmugmugBgScene.init()
    wnJnotePosition.init()
    faq.init()
    imageCarousel.init()
    imageModal.init()
    broadwayShows.init()
    lottieRollover.init()
    scrollCue.init()
    star.init()
    singleVideo.init()
    setTimeout( function() {
        siteAOS.init()
        siteAOS.refreshAOS()
    },500)
})
